import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import emailjs from "emailjs-com";
import Constants from "../constants/constants";

@Injectable({
    providedIn: "root",
})
export class MailService {
    private readonly SERVICE_ID = environment.emailJs.serviceId;
    private readonly TEMPLATE_IDS: any = {};
    private readonly PUBLIC_KEY = environment.emailJs.publicKey;

    constructor() {
        this.TEMPLATE_IDS[Constants.ConfirmationTemplateIdKey] = environment.emailJs.confirmationTemplateId;
        this.TEMPLATE_IDS[Constants.loginTemplateIdKey] = environment.emailJs.loginTemplateId;
        emailjs.init(this.PUBLIC_KEY);
    }

    async sendMail(templateParams: any, templateIdKey: string): Promise<boolean> {
        const templateId = this.TEMPLATE_IDS[templateIdKey];
        if(!templateId) {
            console.error(`Template ID for key ${templateIdKey} not found.`);
            return Promise.resolve(false);
        }
        await emailjs.send(
            this.SERVICE_ID,
            templateId,
            templateParams
        );
        return Promise.resolve(true);
    }
}
